import * as types from './actionTypes';
import {createAction} from 'redux-actions';

export const ratesSelect = createAction(types.RATES_SELECT);
export const ratesFetchSuccess = createAction(types.RATES_FETCH_SUCCESS);
export const ratesFetchError = createAction(types.RATES_FETCH_ERROR);
